// extracted by mini-css-extract-plugin
export var hasSwoosh = "styledHeading-module--has-swoosh--6Xo8K";
export var inner = "styledHeading-module--inner--VwjBm";
export var wrapper = "styledHeading-module--wrapper--bHkAd";